import { render, staticRenderFns } from "./PrevDistrib.vue?vue&type=template&id=90dc403e&scoped=true"
import script from "./PrevDistrib.vue?vue&type=script&lang=js"
export * from "./PrevDistrib.vue?vue&type=script&lang=js"
import style0 from "./PrevDistrib.vue?vue&type=style&index=0&id=90dc403e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dc403e",
  null
  
)

export default component.exports